import { Injectable, NgZone } from '@angular/core';

// If you import a module but never use any of the imported values other than as TypeScript types,
// the resulting javascript file will look as if you never imported the module at all.
//import { ipcRenderer, webFrame, remote } from 'electron';
import * as childProcess from 'child_process';
import * as fs from 'fs';
import { AppState } from '../app-state';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ElectronService {
  ipcRenderer: any;
  webFrame: any;
  remote: any;
  childProcess: typeof childProcess;
  findInPage: any;
  fs: typeof fs;

  constructor(private appState : AppState, 
      private ngZone: NgZone,
      private router: Router,
      private authenticationService: AuthenticationService ) 
  {
    // Conditional imports
    if (appState.isElectron()) {
      this.ipcRenderer = window.require('electron').ipcRenderer;
      this.webFrame = window.require('electron').webFrame;
      this.remote = window.require('electron').remote;
      this.childProcess = window.require('child_process');
      this.fs = window.require('fs');
    }
  }

  initApp() {
    if ( !this.appState.isElectron() ) {
      return      
    }

    // handle electron main window logout menu item clicked
    this.ipcRenderer.on('file.logout', (sender, customArg) => {
      this.ngZone.run(() => {
        this.logout();
      })
    });

    this.ipcRenderer.on('app.exit', (sender, customArg) => {
      this.ngZone.run(() => {
        this.exit();
      })
    });

    const FindInPage = window.require('electron-find').FindInPage
    const findInPage = new FindInPage(this.remote.getCurrentWebContents(), {
      preload: true,
    })
    this.ipcRenderer.on('edit.find', (e, args) => {
      findInPage.openFindWindow()
    })
  
  }

  
  // enable/disable electron main window login menu item
  updateLoginStatus() {
    if ( this.appState.isElectron() ) {
      const user = this.appState.getUser()
      if (user) {
        this.ipcRenderer.send('loggedIn', user.email)
      } else {
        this.ipcRenderer.send('loggedOut', null)
      }
    }
  }

  logout() {
    var userName = this.appState.getUser()?.email
    this.authenticationService.logout();
    this.router.navigate(['/login']);
    var ipc = window.require('electron').ipcRenderer;
    ipc.send('loggedOut', userName)
  }
  
  exit() {
    this.appState.confirmExit( () => { 
      console.log('AppComponent.exit() sending exitConfirmed')
      this.ipcRenderer.send('exitConfirmed',true)
    })
  }



}
